import { render, staticRenderFns } from "./BlockDesigner.vue?vue&type=template&id=27ac42f2&scoped=true&"
import script from "./BlockDesigner.vue?vue&type=script&lang=js&"
export * from "./BlockDesigner.vue?vue&type=script&lang=js&"
import style0 from "./BlockDesigner.vue?vue&type=style&index=0&id=27ac42f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ac42f2",
  null
  
)

export default component.exports